var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalAgreements',{attrs:{"title":_vm.$t('labels.accessibilitypolicy'),"get-url":"/admin/agreement/accessibility-policy","post-url":"/admin/agreement/accessibility-policy"}})}
var staticRenderFns = []

export { render, staticRenderFns }